import { gql } from '@apollo/client';

import { BackupMemberFragment } from './backupMembers.fragment';

export * from './backupMembers.query.generated';

export const BACKUP_MEMBERS = gql`
  query backupMembers(
    $backupId: ID!
    $orderBy: BackupMembersOrderByEnum
    $order: QueryOrderEnum
    $page: Int
    $perPage: Int
    $query: String
  ) {
    backupMembers(
      backupId: $backupId
      orderBy: $orderBy
      order: $order
      page: $page
      perPage: $perPage
      query: $query
    ) {
      nodes {
        ...BackupMemberFragment
      }
      pagesCount
      nodesCount
      hasNextPage
      hasPreviousPage
    }
  }
  ${BackupMemberFragment}
`;
